export { default } from "./Gauge";
